import {useMemo} from 'react';
import {APP_ROUTES, APP_ROUTES_TO_URL, APP_SINGLE_PAGE_ROUTES} from '../../constants';
import {IRouteItem, TSingleRouteKey, TSingleRoutes} from '../../types';

export const useSinglePageRoutes = () => {
    const routesFactory = () => {
        const routes = APP_SINGLE_PAGE_ROUTES.reduce(
            (urls: Record<string, IRouteItem<TSingleRoutes>>, section: TSingleRouteKey) => {
                const url = () => APP_ROUTES_TO_URL[section];
                const to = () => url();
                urls[section] = {section: APP_ROUTES[section], to, url};
                return urls;
            },
            {},
        );

        return routes as Record<TSingleRouteKey, IRouteItem<TSingleRoutes>>;
    };

    return useMemo(routesFactory, []);
};
